<template>
    <div class="import-data-history-content conmon-top">
        <el-row class="search-title common-table-top">
            <el-col :span="4" style="text-align: left;">
                <i class="el-icon-document" style="font-weight: bold;"></i>
                <span class="order-list-search-span">导出记录</span>
            </el-col>
        </el-row>
        <el-row class="import-data-title table-first-style guanyi-menu">
            <el-table
                    :data="tableData"
                    v-loading="loading"
                    class="table">
                <el-table-column
                        prop="create_time"
                        label="导出时间"
                        width="">
                    <template slot-scope="scope">
                        {{ scope.row.create_time | formatDate }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="user_name"
                        label="操作用户"
                        width="">
                </el-table-column>
                <el-table-column
                        prop=""
                        label="导出状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status === 1">
                            <!-- <i style="color: green; font-size: 40px; margin-right: 10px; line-height: 23px;">·</i> -->
                            已导出
                        </div>
                        <div v-if="scope.row.status === 0">
                            <!-- <i style="color: red; font-size: 40px; margin-right: 10px; line-height: 23px;">·</i> -->
                            导出失败
                        </div>
                        <div v-if="scope.row.status === 2">
                            <!-- <i style="color: red; font-size: 40px; margin-right: 10px; line-height: 23px;">·</i> -->
                            导出中
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop=""
                        label="导出结果">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status === 1">
                            <b style="color: green;">{{ scope.row.record_count }}</b>条导出成功
                        </div>
                        <div v-if="scope.row.status === 0">
                            <b style="color: red;">{{ scope.row.record_count }}</b>条导出失败
                        </div>
                        <div v-if="scope.row.status === 2">
                            <b style="color: red;">{{ scope.row.record_count }}</b>条导出中
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop=""
                        width="100"
                        label="操作">
                    <template slot-scope="scope">
                        <div class="op-link" v-if="scope.row.status === 1">
                            <!--                <button @click="downloadFiles(scope.row.qiniu_filename)">下载</button>-->
                            <a :href="scope.row.qiniu_filename" download="qiniu_filename">下载</a>
                        </div>
                        <!--            <div class="op-link" v-if="scope.row.status === 2" @click="look(scope.row.id)">-->
                        <!--              查看-->
                        <!--            </div>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-foot">
                <el-pagination
                        class="table-foot-pagination"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-size="limit"
                        layout="total, prev, pager, next, jumper"
                        :total="totalCount">
                </el-pagination>
            </div>
            <!--导出进度弹窗-->
            <el-dialog class="cellDialog base-dialog" title="导出进度" :visible.sync="scheduleDialog" width="520px">
                <el-progress :percentage="schedule"></el-progress>
                <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                    <el-button class="dialog-cancel-btn" @click="scheduleDialog = false" style="margin-left: 20px">取 消</el-button>
                    <el-button class="dialog-confirm-btn" type="primary" @click="scheduleDialog = false">确 定</el-button>
                </div>
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
  import { exportDownLog, getExportDataHistoryList, lookExporDetail, getExportOrderList } from '@/api/customer.js'

  export default {
    name: 'importData',
    data () {
      return {
        loading: true,
        schedule: 0,
        scheduleDialog: false,
        tableData: [],
        page: 1,
        limit: 10,
        totalCount: 0
      }
    },
    methods: {
      // 打开查看弹窗
      look(id) {
        this.scheduleDialog = true
        lookExporDetail(id).then((res) => {
          if (res.data.code === 0) {
            this.schedule = res.data.data.progress
          }
        })
        let timer = setInterval(() => {
          lookExporDetail(id).then((res) => {
            if (res.data.code === 0) {
              this.schedule = res.data.data.progress
              if (this.schedule === 100) {
                clearInterval(timer)
                this.scheduleDialog = false
                this.load()
              }
            }
          })
        }, 1000)
      },
      // 载入列表
      load() {
        this.loading = true
        if(this.$route.query.type === 'order') {
          getExportOrderList(this.page).then((res) => {
            console.log(res)
            if (res.data.code === 200 || res.data.code === '200') {
              let newList = []
              res.data.result.list.forEach(function(item, index){
                newList.push({
                  create_time: item.createTime,
                  user_name: item.userName,
                  status: item.status,
                  record_count: item.recordCount,
                  model_name: item.modelName,
                  qiniu_filename: item.qiniuFilename
                })
              })
              this.tableData = newList
              this.totalCount = res.data.result.total
            }
          })
        } else {
          getExportDataHistoryList(this.page).then((res) => {
            console.log(res)
            if (res.data.code === 0) {
              this.tableData = res.data.data.list
              this.totalCount = res.data.data.count
            }
          })
        }
        this.openLoading()
      },
      // 数据加载时的动画
      openLoading() {
        setTimeout(() => {
          this.loading = false
        }, 500)
      },
      // 处理分页
      handleSizeChange(val) {
        this.limit = val
        this.load()
      },
      handleCurrentChange(page) {
        this.page = page
        this.load()
      },
      download (data) {
        if (!data) {
          return
        }
        var now = new Date()
        var year = now.getFullYear()
        var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
        console.log(month)
        var date = now.getDate()
        var hour = now.getHours()
        var minute = now.getMinutes()
        var second = now.getSeconds()
        let time = ''
        time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
        var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.href = href
        downloadElement.download = time + '.xlsx' // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      },
      // 下载Excel
      downloadFiles(id) {
        // exportDownLog(id).then(response => {
        //   let reg = new RegExp('json')
        //   if (reg.test(response.headers['content-type'])) {
        //     console.log('response.data', response.data)
        //     _g.toastMsg('error', '您没有下载权限')
        //     return
        //   }
        //   this.download(response)
        // }).catch((error) => {
        //   console.log(error)
        //   _g.toastMsg('error', '文件不存在')
        // })
      },
      // 下载文件
      download (data) {
        if (!data) {
          return
        }
        var now = new Date()
        var year = now.getFullYear()
        var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
        console.log(month)
        var date = now.getDate()
        var hour = now.getHours()
        var minute = now.getMinutes()
        var second = now.getSeconds()
        let time = ''
        time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
        var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.href = href
        downloadElement.download = time + '.csv' // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      }
    },
    created() {

      this.load()
    },
    components: {
    }
  }
</script>

<style scoped>
    .import-data-title {
        text-align: left;
    }
    .export-success {
        display: flex;
        justify-content: center;
    }
    .export-status {
        display: flex;
        justify-content: center;
    }
    .search-title {
        margin-top: 20px;
    }
</style>
